export function iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function (obs) { return obs[method] && observersWithMethod.push(obs); });
    observersWithMethod.forEach(function (obs) { return obs[method](argument); });
}
//# sourceMappingURL=iteration.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/utilities/observables/iteration.js
// module id = ./node_modules/@apollo/client/utilities/observables/iteration.js
// module chunks = 54 55